import { render, staticRenderFns } from "./UserProfileFooter.vue?vue&type=template&id=63c4881f&"
import script from "./UserProfileFooter.vue?vue&type=script&lang=js&"
export * from "./UserProfileFooter.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports